import * as React from "react";
import Typography from "../components/Typography";
import Paragraph from "../components/Paragraph";
import "../styles/global.css";
import Contact from "../components/Contact";
import { Header } from "../components/Header";
import IMG from "../assets/images/IMG_20190428_140824.jpg";
import Img from 'gatsby-image';


// markup
const IndexPage = () => {
  return (
    <main className="bg-gray-50">
      <Header />
      <div className="block xl:flex">
        <section className="font-sans pt-28 md:pt-36 p-5 md:p-14 container flex-1">
          <div className="pb-3">
            <span 
              className="
                text-gray-500
                text-sm
                font-semibold
              ">ABOUT ME</span>
            <Typography title="Hi, I'm Mahdi." />
          </div>
          <Paragraph>
            I'm Mahdi, a 27 year old self-taught Javascript Developer
          </Paragraph>
          <Paragraph>
            After my university degree in "Electronics Engineering" , I felt
            like the it is essential to learn programming languages so I decided
            to learn C# after that I realized I'm much more into web and mobile
            applications development rather than programming hardwares.
          </Paragraph>
          <Paragraph>
            So like anybody else I started learning fundamental of web
            development started with HTML and CSS and Javascript. In January
            2018 I decided to take the risk and quit my job. I’ve been studying
            Front-end development full time ever since.
          </Paragraph>
          <Paragraph>
            I always want to learn more and do more. I'm also a firm believer
            that we should never settle. I'm hard working, super curious,
            passionate, committed and a fast learner!
          </Paragraph>
          <Paragraph>
            During this time, I took online courses like -
            <a
              target="_blank"
              href="https://www.udemy.com/advanced-css-and-sass/"
            >
              [Advanced CSS and Sass: Flexbox, Grid, Animations and More!]
            </a>
            -
            <a
              target="_blank"
              href="https://www.udemy.com/the-complete-javascript-course"
            >
              [The Complete Javascript Course]
            </a>
            -
            <a target="_blank" href="https://javascript30.com/">
              [Javascript30]
            </a>
            -
            <a
              target="_blank"
              href="https://www.udemy.com/understand-javascript"
            >
              [Understanding the Weird Parts]
            </a>
            -
            <a target="_blank" href="https://es6.io">
              [ES6]
            </a>
            -
            <a
              target="_blank"
              href="https://www.youtube.com/watch?v=8t0vNu2fCCM"
            >
              [Gatsby Bootcamp]
            </a>
            -
            <a
              target="_blank"
              href="https://github.com/getify/You-Dont-Know-JS"
            >
              read book series ["You don’t know JS"]
            </a>
            <br />
            and also watched countless youtube videos about Javascript.
          </Paragraph>

          <Contact />
        </section>
        <section className="h-screen w-1/4 hidden xl:block">
          <img 
            src={IMG}
            fluid={IMG}
            alt="IMG"
            className="
              h-full
              object-cover
            "
            style={{
              clipPath: 'polygon(30% 0%, 100% 0%, 100% 100%, 0% 100%)',
              zIndex: -1,
              filter: 'grayscale(1)'
            }}
          />
        </section>
      </div>
    </main>
  );
};

export default IndexPage;
